import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import Context from 'frontools/core/Context';

export default class SwiperManager extends AbstractDispatcher {
    
    private _elSwipers       : NodeListOf<HTMLElement>;
    private _elSwipersMobile : NodeListOf<HTMLElement>;

    private _swipers         : Array<Swiper>           = [];
    private _mobileSwipers   : Array<Swiper>           = [];


    private _maxWidth        : number;
    private _maxHeight       : number;
    private _ratio           : number;

    constructor() {
        super();        
        this.createSwipers();
    }

    public createSwipers() {
        this._elSwipers = document.querySelectorAll('.m_slider') as NodeListOf<HTMLElement>;
        for (let index = 0; index < this._elSwipers.length; index++) {
            if (this._elSwipers[index].querySelectorAll('.swiper-slide').length < 2) {
                this._elSwipers[index].className += ' unique_slide wrap';
                continue;
            }
            this._swipers.push(this._createSwiper(this._elSwipers[index]));
        }
    }

    private _createSwiper(element:HTMLElement) {    
        let elWrapper = element.querySelector('.swiper-wrapper');
        let elPagination = element.querySelector('.swiper-pagination');
        let elNext = element.querySelector('.swiper-button-next');
        let elPrev = element.querySelector('.swiper-button-prev');
        var swiper = new Swiper(element, {   
            slidesPerView: 'auto',  
            // speed: 400,
            setWrapperSize: true,
            spaceBetween: 30,
            preventClicks: true,
            preventClicksPropagation: true,
            centeredSlides: true,
            nextButton: elNext,
            prevButton: elPrev,
            pagination: elPagination,
            paginationClickable: true,
            paginationType: 'custom',
            paginationCustomRender: function (swiper, current, total) {
                return current + '/' + total;
            },
            // breakpoints: {
            //     768: {
            //         slidesPerView: 1.17,
            //         spaceBetween: 15,
            //     }   
            // },
            onInit: (swiper) => {
                setTimeout(()=> {
                    this.onResize();
                }, 1000) 
            }
        });
        return swiper;
    }

    public createSwipersMobile() {
        this._elSwipersMobile = document.querySelectorAll('.m_slider_mobile') as NodeListOf<HTMLElement>;
        for (let index = 0; index < this._elSwipersMobile.length; index++) {
            if (this._elSwipersMobile[index].querySelectorAll('.swiper-slide').length < 2) {
                this._elSwipersMobile[index].className += ' unique_slide wrap';
                continue;
            }
            var swiper = this._createSwiper(this._elSwipersMobile[index]);
            this._mobileSwipers.push(swiper);
        }
        console.log('resizing images')
        for (let i = 0; i < this._mobileSwipers.length; i++) {    
            this._resizeImage(this._mobileSwipers[i])
        }
    }
    
    public destroySwipersMobile() {
        for (let index = 0; index < this._mobileSwipers.length; index++) {
            let swiper = this._mobileSwipers[index];
            if (swiper) {
                swiper.destroy(true,true);  
                swiper = undefined;
            }
        }
        this._mobileSwipers = [];
    }

    public get swipers() : Array<any> {
        return this._swipers;
    }

    public resizeDesktop() {
        for (var i = 0; i < this._swipers.length; i++) {
            this._swipers[i].update(true);
        }
    }

    public destroySwipersDesktop() {
        for (let index = 0; index < this._swipers.length; index++) {
            let swiper = this._swipers[index];
            if (swiper) {
                swiper.destroy(true,true);  
                swiper = undefined;
            }
        }
        this._swipers = [];
    }

    public get mobileSwipers() : Array<any> {
        return this._mobileSwipers;
    }

    /**  
     * onResize - Resize handler
     * 
     */
    public onResize() {
        this._maxWidth = (Math.round(Context.getInstance().viewport.width) * .90) - 60;
        this._maxHeight = (Math.round(Context.getInstance().viewport.height) * .90) - 200;

        this._resizeSlides();    
    }

    private _resizeSlides() {
        for (let i = 0; i < this._swipers.length; i++) {    
            this._resizeImage(this._swipers[i])
        }
        for (let i = 0; i < this._mobileSwipers.length; i++) {    
            this._resizeImage(this._mobileSwipers[i])
        }
    }

    private _resizeImage(swiper) {
        let slides = (swiper as any).container[0].querySelectorAll('.swiper-slide') as NodeListOf<HTMLElement>;
        
        
        for (let j = 0; j < slides.length; j++) {
            if (slides[j].classList.contains('js-no-resize')) {
                continue;
            }
            let slide = slides[j], ratio,
                img = slide.querySelector('img') as HTMLElement;
            
            let ratioElement = slide.querySelector('[data-ratio]') as HTMLElement;

            if (ratioElement) { 
                ratio = Number(ratioElement.getAttribute('data-ratio'));

                let height = this._maxHeight,
                width = Math.round(this._maxHeight / ratio);

                if (width > this._maxWidth) {
                    width = this._maxWidth;
                    height = this._maxWidth * ratio;
                }
                
                slide.style.height = `${height}px`;
                slide.style.width = `${width}px`;
            }
            
        }
        swiper.onResize();
    }

    
}